import gql from 'graphql-tag'

export const GET_USER_QUERY = gql`
    query GetUser {
        getUserData {
            adultEnabled
            email
            isAccountActive
            registrationDate
            patreonStatus {
                fullName
                patreonName
                isPatron
                lastCharged
                lifetimePledgeCents
            }
        }
    }
`

export const GET_AT_HOME_CLIENTS_QUERY = gql`
    query GetAtHomeClients {
        getPaperbackAtHomeClients {
            secret
            isEnabled
            associatedUser
        }
    }
`

export const GET_AT_HOME_CLIENT_QUERY = gql`
    query GetAtHomeClient {
        getPaperbackAtHomeClient {
            secret
            isEnabled
            associatedUser
        }
    }
`

export const UPDATE_ADULT_MUTATION = gql`
    mutation UpdateAdult($status: AdultContentSetting!) {
        updateAdultState(state: $status)
    }
`
